import * as ActionTypes from '../constants/ActionTypes'
import {getStepOrder} from "../selectors/UserInterface";
import {getCartSummary, getMainArticleInCart} from "../selectors/Cart";
import {getSandboxModeFlag, getSimpleModeFlag, isGTMDisabled} from "../selectors/GetParam";
import {getAppMode} from "../selectors/Mode";
import {delve} from "../util/util";
import {getArticleOptionsData, getCartId, getCartTesting} from "../selectors/SimpleSelectors";
import {isUserAuthenticated} from "../selectors/Forms";


let trackedSteps = []

export default store => next => action => {

    if (getSandboxModeFlag() || isGTMDisabled() || document.location.hostname === "localhost") {
        return next(action);
    }

    if (getSimpleModeFlag()) {
        return next(action);
    }

    let state, toReturn, appMode, mainArticleInCart, mainArticleTitle, mainArticleType;

    switch (action.type) {

        case ActionTypes.CART_CREATE_SUCCESS:

            toReturn = next(action);
            state = store.getState();

            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'cart_create',
                    checkoutCart: getCartId(state)
                });
            }

            return toReturn;

        case ActionTypes.CLIENTDATA_SUCCESS:
        case ActionTypes.APP_INITIALIZED:
        case ActionTypes.BASE_ARTICLE_SUCCESS:
        case ActionTypes.STEP_SELECTED:
        case ActionTypes.STEP_CONTROL_NEXT:

            toReturn = next(action);

            state = store.getState();

            const stepOrder = getStepOrder(state);

            const stepAfter = state.ui.currentStep;
            const stepsCompletedAfter = state.ui.stepsCompleted;

            if (!stepAfter) {
                return next(action);
            }

            let checkoutStepName = '';
            appMode = getAppMode();

            mainArticleInCart = getMainArticleInCart(state);
            mainArticleTitle = delve(getArticleOptionsData(state), mainArticleInCart + ".title");
            mainArticleType = delve(getArticleOptionsData(state), mainArticleInCart + ".type");

            let virtualPageViewKey = '/bestellung/';

            // add app mode
            if (appMode) {
                virtualPageViewKey += appMode + '/';
            } else {
                virtualPageViewKey += 'leer/';
            }

            // add client mode
            if (isUserAuthenticated(state)) {
                virtualPageViewKey += 'bestandskunde/';
            } else {
                virtualPageViewKey += 'neukunde/';
            }

            // add article type
            if (mainArticleType) {
                virtualPageViewKey += mainArticleType.toLowerCase().replace(/ /g, "-") + '/';
            } else {
                virtualPageViewKey += 'leer' + '/';
            }

            // add article name
            if (mainArticleTitle) {
                virtualPageViewKey += mainArticleTitle.toLowerCase().replace(/ /g, "-") + '/';
            } else {
                virtualPageViewKey += 'leer/';
            }

            // add step label
            if (stepAfter) {
                checkoutStepName = stepAfter;
                virtualPageViewKey += stepAfter + '-' + (stepOrder.indexOf(stepAfter) + 1) + '/';
            } else {
                checkoutStepName = 'leer';
                virtualPageViewKey += 'leer/';
            }


            if (!trackedSteps.includes(virtualPageViewKey)) {
                trackedSteps.push(virtualPageViewKey);

                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'sendVirtualPageview',
                        vpv: virtualPageViewKey
                    });
                    window.dataLayer.push({
                        event: 'checkout_step',
                        checkoutStepName,
                        checkoutMode: appMode,
                        checkoutMainArticleNumber: mainArticleInCart ? mainArticleInCart + '' : '',
                        checkoutMainArticleName: mainArticleTitle ? mainArticleTitle.toLowerCase().replace(/ /g, "-") : '',
                        checkoutBaseArticle: delve(store.getState(), 'articleData.baseArticle.articleNumber'),
                        checkoutCart: (store && store.getState().cart && store.getState().cart.id),
                        stepIndex: stepOrder.indexOf(stepAfter) + 1,
                        checkoutStepIndex: stepOrder.indexOf(stepAfter) + 1,
                        vpv: virtualPageViewKey
                    });
                }
            }

            stepsCompletedAfter.forEach(step => {
                if (!trackedSteps.includes(step)) {
                    trackedSteps.push(step);
                }
            })

            return toReturn


        case ActionTypes.CART_CHECKOUT_REQUEST:

            state = store.getState();

            const cartId = state.cart.id
            const cartIsTesting = getCartTesting(state);
            const commission = state.cart.commission ? state.cart.commission : 0;
            const cartSummary = getCartSummary(state);

            mainArticleInCart = getMainArticleInCart(state);
            mainArticleTitle = delve(getArticleOptionsData(state), mainArticleInCart + ".title");

            let contractMultiplier = 1;

            let transactionProducts = [];
            let transactionTotal = 0;

            if (cartSummary.baseArticle && cartSummary.baseArticle.articleNumber) {

                const cartContainsBaseArticle = cartSummary.cartItems.some((item) => {
                    return item.identifier === "" + cartSummary.baseArticle.articleNumber;
                })

                if (cartContainsBaseArticle) {
                    transactionProducts.push({
                        sku: cartSummary.baseArticle.articleNumber,
                        name: cartSummary.baseArticle.title,
                        category: cartSummary.baseArticle.type,
                        price: parseFloat(cartSummary.baseArticle.priceMonthly * contractMultiplier + cartSummary.baseArticle.setupFee),
                        quantity: 1
                    });
                    transactionTotal += parseFloat(cartSummary.baseArticle.priceMonthly * contractMultiplier + cartSummary.baseArticle.setupFee)
                }
            }

            cartSummary.domains.forEach(domainOption => {

                transactionProducts.push({
                    sku: 0,
                    name: String(domainOption.domainEnding).toUpperCase() + "-Domain",
                    category: "domain",
                    price: parseFloat(domainOption.priceMonthly * contractMultiplier + domainOption.setupFee),
                    quantity: 1
                });
                transactionTotal += parseFloat(domainOption.priceMonthly * contractMultiplier + domainOption.setupFee);

            })

            cartSummary.articleOptions.forEach(articleOption => {

                contractMultiplier = 1

                transactionProducts.push({
                    sku: parseInt(articleOption.articleNumber, 10),
                    name: articleOption.title,
                    category: articleOption.type || "addon",
                    price: parseFloat(articleOption.priceMonthly * contractMultiplier + articleOption.setupFee),
                    quantity: 1
                });
                transactionTotal += parseFloat(articleOption.priceMonthly * contractMultiplier + articleOption.setupFee);

            })

            appMode = getAppMode();

            let dataLayerObject = {
                event: 'checkout',
                checkoutMode: appMode || 'leer',
                commission: commission,
                checkoutMainArticleNumber: mainArticleInCart ? mainArticleInCart + '' : '',
                checkoutMainArticleName: mainArticleTitle ? mainArticleTitle.toLowerCase().replace(/ /g, "-") : '',
                transactionId: cartId,
                transactionAffiliation: 'mittwald_de',
                transactionTotal: transactionTotal,
                transactionTax: transactionTotal * 0.19,
                transactionIsTesting: cartIsTesting ? 1 : 0,
                transactionShipping: 0,
                transactionProducts: transactionProducts
            }

            if (window.dataLayer) {
                window.dataLayer.push(dataLayerObject);
            }

            return next(action);

        default:
            return next(action);

    }
}



/** WEBPACK FOOTER **
 ** ./src/middleware/GTM.js
 **/